<template>
  <div class="container py-4">
    <!-- Cài đặt đơn hàng -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header fw-bold">🛒 Cài đặt đơn hàng</div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Số ngày tạm giữ đơn hàng:</label>
            <div class="input-group">
              <input
                v-model="model.numberHoldingDay"
                type="number"
                class="form-control"
              />
              <span class="input-group-text bg-warning text-white">Ngày</span>
            </div>
            <small class="form-text text-muted">
              Đơn hàng sẽ tự động hủy sau số ngày này nếu chưa xử lý.
            </small>
          </div>

          <div class="col-md-6">
            <label class="form-label">Số ngày sửa đơn hàng:</label>
            <div class="input-group">
              <input
                v-model="model.editOrderDays"
                type="number"
                class="form-control"
              />
              <span class="input-group-text bg-warning text-white">Ngày</span>
            </div>
            <small class="form-text text-muted">
              Thời gian cho phép chỉnh sửa thông tin đơn sau khi tạo. Nếu bạn muốn cài đặt riêng cho từng chức vụ thì vào phần <a href="javascript:void(0)" @click="openDayLimitTab">Quản lý chức vụ</a> để cài đặt.
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- Cài đặt bán hàng -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header fw-bold">📦 Cài đặt bán hàng</div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Số ngày được phép trả hàng:</label>
            <div class="input-group">
              <input
                v-model="model.numberReturnDay"
                type="number"
                class="form-control"
              />
              <span class="input-group-text bg-warning text-white">Ngày</span>
            </div>
            <small class="form-text text-muted">
              Khách hàng có thể trả hàng trong vòng số ngày này kể từ khi mua.
            </small>
          </div>

          <div class="col-md-6">
            <label class="form-label">Số ngày sửa hóa đơn:</label>
            <div class="input-group">
              <input
                v-model="model.numberUpdateBill"
                type="number"
                class="form-control"
              />
              <span class="input-group-text bg-warning text-white">Ngày</span>
            </div>
            <small class="form-text text-muted">
              Cho phép sửa hóa đơn trong số ngày quy định kể từ ngày xuất. Nếu muốn cài đặt riêng cho từng chức vụ thì vào phần <a href="javascript:void(0)" @click="openDayLimitTab">Quản lý chức vụ</a> để cài đặt.
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- Cài đặt kế toán -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header fw-bold">💰 Cài đặt kế toán</div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Phí quẹt thẻ:</label>
            <div class="input-group">
              <input
                v-model="model.creditFee"
                type="number"
                class="form-control"
              />
              <span class="input-group-text bg-primary text-white">%</span>
            </div>
            <small class="form-text text-muted">
              Tỷ lệ phần trăm phí khi khách hàng thanh toán bằng thẻ.
            </small>
          </div>

          <div class="col-md-6">
            <label class="form-label">Phí thu hộ trả góp:</label>
            <div class="input-group">
              <input
                v-model="model.installmentFee"
                type="number"
                class="form-control"
              />
              <span class="input-group-text bg-primary text-white">%</span>
            </div>
            <small class="form-text text-muted">
              Tỷ lệ phần trăm phí áp dụng cho giao dịch trả góp.
            </small>
          </div>
        </div>
      </div>
    </div>

        <!-- Cài đặt bảo hành -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header fw-bold">💰 Cài đặt bảo hành</div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Số ngày cập nhật phiếu bảo hành:</label>
            <div class="input-group">
              <input
                v-model="model.numberUpdateWarranty"
                type="number"
                class="form-control"
              />
                <span class="input-group-text bg-warning text-white">Ngày</span>
            </div>
            <small class="form-text text-muted">
              Cho phép sửa phiếu bảo hành ở các trạng thái ngoại trừ <span class="font-weight-bold text-danger">Hoàn thành, Đã trả</span> trong số ngày quy định kể từ ngày tạo phiếu.
            </small>
          </div>

          <div class="col-md-6">
          </div>
        </div>
      </div>
    </div>

    <!-- Cài đặt bảo mật -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header fw-bold">🔒 Cài đặt bảo mật</div>
      <div class="card-body">
        <div class="d-flex align-items-center justify-content-between py-2">
          <div>
            <div class="font-weight-bold">Kiểm soát truy cập theo IP</div>
            <small class="text-muted">
              Khi bật, chỉ các địa chỉ IP trong danh sách whitelist hoặc có ngoại lệ bypass mới được phép đăng nhập và sử dụng hệ thống.
            </small>
          </div>
          <b-form-checkbox
            v-model="model.ipCheckEnabled"
            switch
            size="lg"
            class="ml-4"
          />
        </div>
      </div>
    </div>

    <!-- Nút lưu -->
    <div class="text-end">
      <button class="btn btn-primary px-4 py-2" @click="onSave">
        Lưu thay đổi
      </button>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';

export default {
  data() {
    return {
      model: {
        numberHoldingDay: 10,
        editOrderDays: 1,
        numberReturnDay: 33,
        numberUpdateBill: 1,
        creditFee: 0,
        installmentFee: 0,
        ipCheckEnabled: false,
      },
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Cài đặt', route: '/settings' },
    ]);
    this.getSetting();
  },
  methods: {
    openDayLimitTab() {
      const routeData = this.$router.resolve({
        path: '/permissions',
        query: { tab: 'day-limit' },
      });
      window.open(routeData.href, '_blank');
    },
    onSave() {
      const payload = {
        id: this.model.id,
        numberUpdateBill: this.model.numberUpdateBill,
        numberReturnDay: this.model.numberReturnDay,
        numberHoldingDay: this.model.numberHoldingDay,
        creditFee: this.model.creditFee,
        installmentFee: this.model.installmentFee,
        numberUpdatingDay: this.model.editOrderDays,
        numberUpdateWarranty: this.model.numberUpdateWarranty,
        ipCheckEnabled: this.model.ipCheckEnabled ? 1 : 0,
      };
      ApiService.put(`v1/settings`, payload)
        .then(({ data }) => {
          makeToastSuccess(data.message);
          this.getSetting();
        })
        .catch((err) => {
          if (!err.response) {
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message || 'Lỗi!';
            makeToastFaile(message);
          }
          this.$nprogress.done();
        });
    },
    getSetting: function () {
      ApiService.get(`v1/settings/lasted`).then((data) => {
        const setting = data.data.data;
        const {
          numberUpdateBill,
          numberReturnDay,
          numberHoldingDay,
          creditFee,
          installmentFee,
          numberUpdatingDay: editOrderDays,
          numberUpdateWarranty,
        } = setting || {};
        this.model.id = setting.id;
        this.model.numberUpdateBill = numberUpdateBill || 1;
        this.model.numberReturnDay = numberReturnDay || 1;
        this.model.numberHoldingDay = numberHoldingDay || 1;
        this.model.creditFee = creditFee || 1;
        this.model.installmentFee = installmentFee || 1;
        this.model.editOrderDays = editOrderDays || 1;
        this.model.numberUpdateWarranty = numberUpdateWarranty || 0;
        this.model.ipCheckEnabled = Boolean(setting.ipCheckEnabled);
      });
    },
  },
};
</script>
